export default "__VITE_PUBLIC_ASSET__a2f8234c__"